<template>
  <v-dialog v-model="show" width="40vw" scrollable>
    <v-card height="auto" elevation="5" class="rounded-xl" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Registros en tiempo
      </v-card-title>
      <v-card-text>
        <div v-if="isLoading">
          <v-row class="text-start mt-2">
            <v-col>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <span class="font-weight-bold font-italic ml-5"
                >Cargando eventos...</span
              >
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item
              fill-dot
              v-for="(log, i) in logs"
              :key="i"
              :color="log.color"
              :icon="getIcon(log.logType)"
            >
              <v-card color="primary" dark>
                <v-card-title class="text-subtitle-1">
                  {{ getType(log.logType) }}</v-card-title
                >
                <v-card-text class="white text--primary">
                  <v-row no-gutters>
                    <v-col cols="12"
                      ><span class="text-caption"
                        ><span class="font-weight-bold font-italic">Hora:</span>
                        {{ dateFormat(log.date) }}</span
                      ></v-col
                    >
                    <v-col cols="12"
                      ><span class="text-caption">
                        <span class="font-weight-bold font-italic"
                          >Usuario:</span
                        >
                        {{ log.user.name }} {{ log.user.lastName }}</span
                      ></v-col
                    >
                    <template v-if="log.logType == 'FIRST_USAGE'">
                      <v-col cols="12"
                        ><span class="text-caption">
                          <span class="font-weight-bold font-italic"
                            >Laboratorio:</span
                          >
                          {{ log.laboratory.name }}</span
                        ></v-col
                      >
                      <v-col cols="12">
                        <span class="text-caption">
                          <span class="font-weight-bold font-italic"
                            >Datos del paquete:
                          </span>
                          <v-spacer></v-spacer>
                          <span
                            >Nombre del paquete:
                            {{ log.package_meta.packageName }}
                          </span>
                        </span>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
          <div v-if="!isLoading && logs.length == 0">
            <v-row class="text-center mt-2">
              <v-col>
                <span class="font-weight-bold font-italic"
                  >No hay registros de eventos</span
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
export default {
  data: () => ({
    isLoading: false,
    logs: [],
  }),
  props: {
    value: Boolean,
    currentPackage: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    getType(value) {
      let values = {
        FIRST_USAGE: "Primer uso",
      };
      return values[value] || value;
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "N/A";
      } else {
        return "N/A";
      }
    },
    getIcon(type) {
      let icon = "";
      switch (type) {
        default:
          icon = "mdi-calendar";
          break;
      }

      return icon;
    },
  },
  mounted() {
    try {
      this.isLoading = true;
      this.logs = this.currentPackage.logs
        ? this.currentPackage.logs.reverse()
        : [];
    } catch (error) {
      console.log(error);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: `Algo salió mal. Error: ${error.message}`,
        timeout: 5000,
      });
    }
    this.isLoading = false;
  },
};
</script>
